import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { ProductPositionFormOptions } from "features/product-position-management/types/ProductPositionFormOptions"
import { ProjectPageProductPositionSidebar } from "pages/project-page/sidebar/product-position/ProjectPageProductPositionSidebar"
import { useProjectPageProductPositionSidebarModel } from "pages/project-page/sidebar/product-position/hooks/useProjectPageProductPositionSidebarModel"

export interface FavoritesPageProductPositionSidebarProps {
  productPosition: ProductPosition
}

const FAVORITES_SIDEBAR_FORM_OPTIONS: ProductPositionFormOptions = {
  hideDisplayPosition: true,
  hideIsAlternative: true,
  hideParentSelection: true,
  hideQuantity: true,
  hidePriceTotal: true,
  hideAttachments: true,
  hideClarificationRequest: true
}

export const FavoritesPageProductPositionSidebarConnector = React.memo(
  ({ productPosition }: FavoritesPageProductPositionSidebarProps) => (
    <ProjectPageProductPositionSidebar
      {...useProjectPageProductPositionSidebarModel({
        productPosition,
        projectID: FAVORITES_PROJECT_ID,
        formOptions: FAVORITES_SIDEBAR_FORM_OPTIONS
      })}
      formOptions={FAVORITES_SIDEBAR_FORM_OPTIONS}
    />
  )
)
